export const COMPONENT_RULES = {
  OR: 'OR',
  MULTIPLE: 'MULTIPLE',
  QUICK_FILTER: 'QUICK_FILTER',
};

export const analyzeFilterRules = (matrix, targetColumnId) => {
  const idOccurrences = {};
  let isColumnIdFound = false;
  let rule = COMPONENT_RULES.QUICK_FILTER;

  matrix?.forEach((filterRule) => {
    const hasId = filterRule.some((rule) => rule.colId === targetColumnId);

    if (filterRule.length >= 2 && hasId) {
      rule = COMPONENT_RULES.OR;
      return;
    }

    if (filterRule.length === 1 && filterRule[0].colId === targetColumnId) {
      idOccurrences[targetColumnId] = (idOccurrences[targetColumnId] || 0) + 1;
      isColumnIdFound = true;
    }
  });

  if (!isColumnIdFound) {
    return rule;
  }

  Object.entries(idOccurrences).forEach(([, count]) => {
    if (count >= 2) {
      rule = COMPONENT_RULES.MULTIPLE;
    }
  });

  return rule;
};
